// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProviderAvatars-module__root___cpV3S {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #3f3f46;
}

.ProviderAvatars-module__avatar___HRlRI {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  border-radius: 999px;
  font-family: "IBM Plex Mono", monospace;
  font-size: 10px;
  font-weight: 600;
  color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/ProviderAvatars/ProviderAvatars.module.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACF","sourcesContent":[".root {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  color: #3f3f46;\n}\n\n.avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 22px;\n  height: 22px;\n  border-radius: 999px;\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 10px;\n  font-weight: 600;\n  color: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ProviderAvatars-module__root___cpV3S`,
	"avatar": `ProviderAvatars-module__avatar___HRlRI`
};
module.exports = ___CSS_LOADER_EXPORT___;
